import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export default function Discover() {
  const [html, setHtml] = useState("");
  useEffect(() => { fetch("/discover-namonics-snippet.html").then((r) => r.text()).then(setHtml); }, []);
  const markup = html.replace(/<!--[\s\S]*?-->/g, "");
  const copy = () => navigator.clipboard.writeText(html).then(() => toast.success("Snippet copied"));
  return (
    <div className="min-h-screen bg-stone-100 pb-20" data-testid="discover-preview-page">
      <div className="border-b border-stone-300 bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-6 py-4">
          <span className="font-serif-display text-xl text-stone-800">whenthetimeisripe.com <span className="text-xs text-stone-400">(preview mock-up)</span></span>
          <nav className="flex flex-wrap items-center gap-4 text-sm text-stone-600 sm:gap-6">
            <span>Calculator</span><span>About</span>
            <span data-testid="discover-nav-tab" dangerouslySetInnerHTML={{ __html: markup.match(/<a[^>]*namonics-nav-tab[\s\S]*?<\/a>/)?.[0] || "" }} />
          </nav>
        </div>
      </div>
      <div className="px-6" data-testid="discover-promo-card" dangerouslySetInnerHTML={{ __html: (markup.match(/<section[\s\S]*<\/section>/)?.[0] || "").replace("https://namonics.whenthetimeisripe.com/namonics-logo-sm.png", "/namonics-logo-sm.png") }} />
      <div className="mx-auto mt-6 max-w-6xl px-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-stone-600">Paste this code into whenthetimeisripe.com (instructions included at the top).</p>
          <button onClick={copy} className="inline-flex items-center gap-2 rounded-full bg-stone-900 px-5 py-2.5 text-sm text-white hover:bg-[#5B2C36]" data-testid="discover-copy-btn"><Copy className="h-4 w-4" /> Copy code</button>
        </div>
        <pre className="mt-4 max-h-96 overflow-auto rounded border border-stone-300 bg-white p-4 text-xs text-stone-700" data-testid="discover-snippet-code">{html}</pre>
      </div>
    </div>
  );
}
